<template>
  <!-- Main content -->
  <section class="content">
    <div class="btn-box">
      <el-form :inline="true">
        <el-form-item label="用户id：">
          <el-input v-model="user_id" placeholder="请输入user_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="seach(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table v-loading="loading" :data="authorizationList" border>
      <el-table-column fixed prop="id" label="编号" width="100">
      </el-table-column>
      <el-table-column prop="channel_id" label="渠道id" width="160">
      </el-table-column>
      <el-table-column prop="owner_user" label="授权者" width="140">
      </el-table-column>
      <el-table-column prop="borrow_user" label="使用者" width="140">
      </el-table-column>
      <el-table-column prop="user_key" label="user_key" width="160">
      </el-table-column>
      <el-table-column prop="open_id_user" label="open_id_user" width="200">
      </el-table-column>
      <el-table-column prop="xid_user" label="xid_user" width="200">
      </el-table-column>
      <el-table-column prop="use_time" label="使用时间" width="180">
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          {{ scope.row.status_code | statusText }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="del(scope.row.id)"
            >删除授权</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes,prev, pager, next,jumper"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
  </section>
  <!-- /.content -->
</template>

<script>
import {
  getJdRelationList,
  clearJdRelation,
} from '@/config/detailManage';

export default {
  name: 'jdAuthorization',
  components: {},
  data() {
    return {
      authorizationList: [],
      total: 0,
      page: 1,
      pagesize: 10,
      user_id: '',
      loading: true,
    };
  },
  watch: {},
  filters: {
    statusText(val) {
      switch (Number(val)) {
        case 1:
          return '使用中';
        case 2:
          return '未使用';
        case 3:
          return '已封停';
        default:
          return val || '';
      }
    },
  },
  mounted() {
    this.getAuthorization();
  },
  methods: {
    async getAuthorization(page, size) {
      this.loading = true;
      const { data } = await getJdRelationList({
        user_id: this.user_id,
        page: page ? page : this.page,
        pagesize: size ? size : this.pagesize,
      });
      this.authorizationList = data.list;
      this.total = Number(data.count);
      this.loading = false;
    },
    sizeChange(val) {
      this.pagesize = val;
      this.getAuthorization();
    },
    currentChange(val) {
      this.page = val;
      this.getAuthorization();
    },
    seach(page, size) {
      this.getAuthorization(page, size);
    },
    async del(id) {
      await this.$confirm('确认清除该京东授权？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      const { msg } = await clearJdRelation(id);
      this.$message({
        type: 'success',
        message: msg,
      });
      this.getAuthorization();
    },
  },
};
</script>
<style scoped>
.cell {
  text-align: center;
}

.btn-box {
  text-align: left;
  margin-bottom: 20px;
}
</style>
